import React from 'react';
import Home from './components/Home';
import Contact from './components/Contact';
import About from './components/About';
import Branches from './components/Branches';
import Special from './components/Special';
import Industriel from './components/Industriel';
import Mining from './components/Mining';
import Awards from './components/Awards';
import Railways from './components/Railways';
import CustomNavbar from './components/CustomNavbar';
import BottomNavbar from './components/BottomNavbar';

import {BrowserRouter as Router, Route} from "react-router-dom";


function App() {
  return (
    <Router>
         <CustomNavbar/> 
         <div>        
         <Route exact path="/" component={Home}/>
         <Route path="/contact" component={Contact}/>
         <Route path="/about" component={About}/>
         <Route path="/awards" component={Awards}/>
         <Route path="/branches" component={Branches}/>
         <Route path="/mining" component={Mining}/>
         <Route path="/special" component={Special}/>
         <Route path="/industriel" component={Industriel}/>
         <Route path="/railway" component={Railways}/>
         </div>
        <BottomNavbar/>  
    </Router>
      );
};

export default App;
